// @ts-nocheck
import Button from '@rio-cloud/rio-uikit/Button';
import { TableColumnsDropdown } from '@rio-cloud/rio-uikit/Table';
import TableToolbar, { TableToolbarColumn } from '@rio-cloud/rio-uikit/TableToolbar';
import TableViewToggles from '@rio-cloud/rio-uikit/TableViewToggles';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import TableDisplayOptionsDropdown from './TableDisplayOptionsDropdown';
import VehicleConditionFilter from './VehicleConditionFilter';

const TableFilterBarWithoutInjection = ({
    columns,
    compactRows,
    downloadTableAsCSV,
    filters,
    intl,
    gridLines,
    intl: { formatMessage },
    onColumnOrderChange,
    onColumnReset,
    onColumnVisibilityChange,
    onToggleCompactRows,
    onToggleGridLines,
    onViewTypeChange,
    viewType,
}) => (
    <TableToolbar>
        <TableToolbarColumn>
            <Button bsStyle={Button.PRIMARY} iconName='download' onClick={downloadTableAsCSV}>
                <FormattedMessage id='intl-msg:csvExport' />
            </Button>
        </TableToolbarColumn>
        <TableToolbarColumn horizontalAlign='right'>
            <TableDisplayOptionsDropdown
                compactRows={compactRows}
                gridLines={gridLines}
                intl={intl}
                onToggleCompactRows={onToggleCompactRows}
                onToggleGridLines={onToggleGridLines}
            />
        </TableToolbarColumn>
        <TableToolbarColumn horizontalAlign='right' separator>
            <VehicleConditionFilter filters={filters} />
        </TableToolbarColumn>
        <TableToolbarColumn horizontalAlign='right'>
            <TableViewToggles
                viewType={viewType}
                onViewTypeChange={onViewTypeChange}
                tableViewLabel={formatMessage({ id: 'intl-msg:table.tableViewToggles.tableViewLabel' })}
                singleCardViewLabel={formatMessage({ id: 'intl-msg:table.tableViewToggles.singleCardViewLabel' })}
                multiCardsViewLabel={formatMessage({ id: 'intl-msg:table.tableViewToggles.multiCardsViewLabel' })}
            />
        </TableToolbarColumn>
        <TableToolbarColumn horizontalAlign='right'>
            <TableColumnsDropdown
                columns={columns}
                label={formatMessage({ id: 'intl-msg:table.tableColumnsDropdown.label' })}
                onColumnOrderChange={onColumnOrderChange}
                onColumnVisibilityChange={onColumnVisibilityChange}
                onReset={onColumnReset}
                showResetButton
                resetLabel={formatMessage({ id: 'intl-msg:table.tableColumnsDropdown.resetLabel' })}
            />
        </TableToolbarColumn>
    </TableToolbar>
);

TableFilterBarWithoutInjection.propTypes = {
    downloadTableAsCSV: PropTypes.func.isRequired,
    filters: PropTypes.array.isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    columns: PropTypes.array.isRequired,
    compactRows: PropTypes.bool.isRequired,
    gridLines: PropTypes.bool.isRequired,
    onColumnOrderChange: PropTypes.func.isRequired,
    onColumnReset: PropTypes.func.isRequired,
    onColumnVisibilityChange: PropTypes.func.isRequired,
    onToggleCompactRows: PropTypes.func.isRequired,
    onToggleGridLines: PropTypes.func.isRequired,
    onViewTypeChange: PropTypes.func.isRequired,
    viewType: PropTypes.string.isRequired,
};

export { TableFilterBarWithoutInjection };

export default injectIntl(TableFilterBarWithoutInjection);
